import { createStandardAction, ActionType } from 'typesafe-actions';

export const globalActions = {
  setExport: createStandardAction('SET_EXPORT')<object>(),
};

export type GlobalActions = ActionType<typeof globalActions>;
